import React, { useState } from "react";
import styled from "@emotion/styled";
import { Button, Form, Select, Modal } from "antd";
import { EditOutlined, LeftOutlined, PlusOutlined } from "@ant-design/icons";
import UITable from "../../../Reusablecomponents/UITable/UITable.js";
import Editicon from "../../../assets/images/Editicon.svg";
import { useNavigate } from "react-router-dom";

const MainDashboardWrapper = styled.div`
  background-color: #f8f9fa;
  padding: 24px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

const ContentHeader = styled.div`
  .container_editicon {
    background-color: white;
    border: 1px solid lightblue;
    padding: 9px;
    border-radius: 50%;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  h2 {
    margin: 0;
    font-size: 18px;
    color: #1a1a1a;
    font-weight: 500;
  }
  .status-badge {
    color: #2e7d32;
    font-weight: 500;
  }
`;

const RoundBackButton = styled(Button)`
  background: #eaf8f0;
  color: #2e7d32;
  border: none;
  &:hover {
    background: #d4f0e0 !important;
    color: #2e7d32 !important;
  }
`;

const TopRightControlGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const CustomInspectedButton = styled(Button)`
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  font-weight: 500;
  &:hover {
    background-color: #236125 !important;
    color: #ffffff !important;
  }
`;

const CustomEditButton = styled(Button)`
  border-color: #faad14;
  color: #faad14;
  &:hover {
    border-color: #d48f10 !important;
    color: #d48f10 !important;
  }
`;

const DetailsGridCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px 16px;
  border: 1px solid #f0f0f0;
`;

const SpecificationItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  .field-label {
    color: #8c9ba5;
    font-size: 19px;
  }
  .field-value {
    color: #2d3748;
    font-size: 17px;
    font-weight: 400;
  }
`;

const DedicatedTableCard = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  margin-top: 24px;
  border: 1px solid #f0f0f0;

  h3 {
    margin-bottom: 16px;
    font-size: 16px;
    color: #1f2937;
    font-weight: 500;
  }
`;

// --- Styled Modal Elements ---
const ModalWrapper = styled.div`
  background: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
`;

const CustomModalHeader = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
    font-weight: 500;
  }
  .close-cross-btn {
    cursor: pointer;
    color: #9ca3af;
    font-size: 18px;
  }
`;

const AntOverriddenForm = styled(Form)`
  padding-top: 24px;

  .ant-form-item-label > label {
    color: #718096 !important;
    font-size: 13px;
  }

  .ant-select-selector {
    border-radius: 20px !important;
    height: 40px !important;
    display: flex;
    align-items: center;
  }
`;

const AttachmentUploadBar = styled.div`
  background-color: #eafaf1;
  border: 1px dashed #b2e2c4;
  border-radius: 20px;
  padding: 10px;
  text-align: center;
  color: #2e7d32;
  cursor: pointer;
  font-weight: 500;
  margin-top: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #d4f5e2;
  }
`;

const ModalActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
`;

const ModalCancelButton = styled(Button)`
  background-color: #eafaf1;
  color: #2e7d32;
  border: none;
  border-radius: 20px;
  padding: 0 24px;
  height: 40px;
  &:hover {
    background-color: #d4f5e2 !important;
    color: #2e7d32 !important;
  }
`;

const ModalSubmitButton = styled(Button)`
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 0 24px;
  height: 40px;
  &:hover {
    background-color: #236125 !important;
    color: #ffffff !important;
  }
`;

// --- Table Column Settings ---
const columns = [
  {
    title: "Inspection Date",
    dataIndex: "inspectionDate",
    key: "inspectionDate",
  },
  {
    title: "Inspection Center",
    dataIndex: "inspectionCenter",
    key: "inspectionCenter",
  },
  {
    title: "Inspection Report",
    dataIndex: "report",
    key: "report",
    render: () => (
      <a
        href="#view-report"
        style={{ color: "#5f6d8c", textDecoration: "underline" }}
      >
        View
      </a>
    ),
  },
  {
    title: "Inspection Sticker",
    dataIndex: "sticker",
    key: "sticker",
    render: () => (
      <a
        href="#view-sticker"
        style={{ color: "#5f6d8c", textDecoration: "underline" }}
      >
        View
      </a>
    ),
  },
];

const tableRowData = Array(5)
  .fill({
    inspectionDate: "20th Feb 2025",
    inspectionCenter: "NTSA Hq",
  })
  .map((row, index) => ({ ...row, key: String(index + 1) }));

const InspectionDashboard = () => {
  const [isInspectedModalOpen, setIsInspectedModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [inspectedForm] = Form.useForm();
  const [editInspectionForm] = Form.useForm();

  const onInspectedSubmit = (formValues) => {
    setIsInspectedModalOpen(false);
  };

  const onEditInspectionSubmit = (formValues) => {
    setIsEditModalOpen(false);
  };

  // --- Specifications Field Mapping ---
  const specsDataset = [
    { label: "Vehicle No", value: "KA12345" },
    { label: "Vehicle Type", value: "Truck" },
    { label: "Model", value: "Axes 100" },
    { label: "Mfg Year", value: "1970" },
    { label: "Internal Dimension of truck", value: "20/20/20" },
    { label: "Cubic Capacity", value: "10,000" },
    { label: "Maximum Load Capacity (in Kg)", value: "20,000" },
    { label: "Fuel Type", value: "Diesel" },
    { label: "Tonnes", value: "-/-" },
    { label: "Link to", value: "-/-" },
    { label: "Status", value: "Active" },
    { label: "Mileage", value: "80" },
    { label: "ODO Reset on", value: "-/-" },
    { label: "Registration Date", value: "24th Aug 2024" },
    { label: "Chassis Number", value: "-/-" },
    { label: "Engine Number", value: "-/-" },
    { label: "Transmission", value: "Manual" },
    { label: "Entity", value: "-/-" },
    { label: "Supplier", value: "-/-" },
    { label: "Driver", value: "-/-" },
    { label: "Last Inspection", value: "20th Feb 2025" },
    { label: "Next Due", value: "20th Feb 2025" },
  ];
  const navigate = useNavigate();

  return (
    <>
      <MainDashboardWrapper>
        <ContentHeader>
          <HeaderTitleGroup>
            <RoundBackButton
              onClick={() => navigate("/Workshop")}
              shape="circle"
              icon={<LeftOutlined />}
            />
            <h2>
              Inspection - KA12345{" "}
              <span className="status-badge">Up to Date</span>
            </h2>
          </HeaderTitleGroup>
          <TopRightControlGroup>
            <CustomInspectedButton
              type="primary"
              shape="round"
              onClick={() => setIsInspectedModalOpen(true)}
            >
              Inspected
            </CustomInspectedButton>
            <div className="container_editicon">
              <img
                src={Editicon}
                onClick={() => setIsEditModalOpen(true)}
                alt="Editicon"
              />
            </div>
          </TopRightControlGroup>
        </ContentHeader>

        <DetailsGridCard>
          {specsDataset.map((spec, i) => (
            <SpecificationItem key={i}>
              <span className="field-label">{spec.label}</span>
              <span className="field-value">{spec.value}</span>
            </SpecificationItem>
          ))}
        </DetailsGridCard>
      </MainDashboardWrapper>

      <DedicatedTableCard>
        <h3>Inspection Logs</h3>
        {/* Render using your clean reusable customized UI table standard */}
        <UITable
          columns={columns}
          dataSource={tableRowData}
          pagination={false}
          scroll={{ y: 300 }}
        />
      </DedicatedTableCard>

      {/* 1. INSPECTED ACTION CREATION MODAL */}
      <Modal
        open={isInspectedModalOpen}
        onCancel={() => setIsInspectedModalOpen(false)}
        footer={null}
        closable={false}
        width={520}
      >
        <ModalWrapper>
          <CustomModalHeader>
            <h3>KA123</h3>
            <span
              className="close-cross-btn"
              onClick={() => setIsInspectedModalOpen(false)}
            >
              ✕
            </span>
          </CustomModalHeader>

          <AntOverriddenForm
            form={inspectedForm}
            layout="vertical"
            onFinish={onInspectedSubmit}
            initialValues={{
              inspectionDate: "20/05/2020",
              inspectionCenter: "NTSA Hq",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
              }}
            >
              <Form.Item label="Inspection Date" name="inspectionDate">
                <Select
                  options={[{ value: "20/05/2020", label: "20/05/2020" }]}
                />
              </Form.Item>
              <Form.Item label="Inspection Center" name="inspectionCenter">
                <Select options={[{ value: "NTSA Hq", label: "NTSA Hq" }]} />
              </Form.Item>
            </div>

            <AttachmentUploadBar
            >
              <PlusOutlined /> Upload Inspection Sticker
            </AttachmentUploadBar>

            <AttachmentUploadBar
              onClick={() =>
                console.log("Attach Comprehensive Report Stream Handle")
              }
            >
              <PlusOutlined /> Upload Inspection Report
            </AttachmentUploadBar>

            <ModalActionRow>
              <ModalCancelButton onClick={() => setIsInspectedModalOpen(false)}>
                Cancel
              </ModalCancelButton>
              <ModalSubmitButton htmlType="submit">Create</ModalSubmitButton>
            </ModalActionRow>
          </AntOverriddenForm>
        </ModalWrapper>
      </Modal>

      {/* 2. EDIT FILTER ROW MODAL */}
      <Modal
        open={isEditModalOpen}
        onCancel={() => setIsEditModalOpen(false)}
        footer={null}
        closable={false}
        width={1000}
      >
        <ModalWrapper>
          <CustomModalHeader>
            <h3>Edit Insurance</h3>{" "}
            {/* Header string layout perfectly references image_17798a.png configuration view */}
            <span
              className="close-cross-btn"
              onClick={() => setIsEditModalOpen(false)}
            >
              ✕
            </span>
          </CustomModalHeader>

          <AntOverriddenForm
            form={editInspectionForm}
            layout="vertical"
            onFinish={onEditInspectionSubmit}
            initialValues={{
              lastInspection: "20/05/2020",
              inspectionCenter: "Comprehensive",
              expiryDate: "1 year",
              alertBefore: "1 Week",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "16px",
              }}
            >
              <Form.Item label="Last Inspection" name="lastInspection">
                <Select
                  options={[{ value: "20/05/2020", label: "20/05/2020" }]}
                />
              </Form.Item>
              <Form.Item label="Insurance Center" name="inspectionCenter">
                <Select
                  options={[{ value: "Comprehensive", label: "Comprehensive" }]}
                />
              </Form.Item>
              <Form.Item label="Expiry Date" name="expiryDate">
                <Select options={[{ value: "1 year", label: "1 year" }]} />
              </Form.Item>
              <Form.Item label="Send Expiry Alert Before" name="alertBefore">
                <Select options={[{ value: "1 Week", label: "1 Week" }]} />
              </Form.Item>
            </div>

            <ModalActionRow>
              <ModalCancelButton onClick={() => setIsEditModalOpen(false)}>
                Cancel
              </ModalCancelButton>
              <ModalSubmitButton htmlType="submit">Create</ModalSubmitButton>
            </ModalActionRow>
          </AntOverriddenForm>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default InspectionDashboard;
